import React, { Component, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import icons from "../../utils/import.icons";

let Amenities = [
  [
    {
      name:"Yoga Deck",
      frame:1,
      pos:[518.277,576.126]
    },{
      name:"Children's Play",
      frame:1,
      pos:[555.057,559.855]
    },{
      name:"Coworking",
      frame:1,
      pos:[620.974,257.784]
    },{
      name:"Laundry",
      frame:1,
      pos:[638.641,263.343]
    },{
      name:"Lobby",
      frame:1,
      pos:[674.231,799.351]
    },{
      name:"Hall",
      frame:1,
      pos:[797.574,468.479]
    },{
      name:"Gym",
      frame:1,
      pos:[1050.7,248.046]
    },{
      name:"BBQ2",
      frame:1,
      pos:[1063.51,218.983]
    },{
      name:"JacuzziView",
      frame:1,
      pos:[1154.71,211.326]
    },{
      name:"Pet Zone",
      frame:1,
      pos:[1160.82,719.939]
    },{
      name:"Children's Pool",
      frame:1,
      pos:[1211.39,210.267]
    },{
      name:"Solarium",
      frame:1,
      pos:[1312.39,209.679]
    },{
      name:"Eco Terrace",
      frame:1,
      pos:[1327.33,215.639]
    },{
      name:"Infinity Pool",
      frame:1,
      pos:[1411.51,221.395]
    },
    ],
    [
    {
      name:"Yoga Deck",
      frame:2,
      pos:[527.181,571.438]
    },{
      name:"Children's Play",
      frame:2,
      pos:[574.265,555.961]
    },{
      name:"Coworking",
      frame:2,
      pos:[623.797,259.966]
    },{
      name:"Laundry",
      frame:2,
      pos:[653.143,265.279]
    },{
      name:"Lobby",
      frame:2,
      pos:[671.498,792.799]
    },{
      name:"Hall",
      frame:2,
      pos:[801.82,467.689]
    },{
      name:"BBQ2",
      frame:2,
      pos:[1058.28,218.093]
    },{
      name:"Gym",
      frame:2,
      pos:[1057,247.369]
    },{
      name:"JacuzziView",
      frame:2,
      pos:[1153.8,209.537]
    },{
      name:"Pet Zone",
      frame:2,
      pos:[1180.63,723.94]
    },{
      name:"Children's Pool",
      frame:2,
      pos:[1212.15,207.934]
    },{
      name:"Solarium",
      frame:2,
      pos:[1324.1,206.344]
    },{
      name:"Eco Terrace",
      frame:2,
      pos:[1332.86,212.315]
    },{
      name:"Infinity Pool",
      frame:2,
      pos:[1423.04,217.428]
    },
    ],
    [
    {
      name:"Yoga Deck",
      frame:3,
      pos:[538.923,566.969]
    },{
      name:"Children's Play",
      frame:3,
      pos:[595.339,552.343]
    },{
      name:"Coworking",
      frame:3,
      pos:[629.092,262.081]
    },{
      name:"Laundry",
      frame:3,
      pos:[669.319,267.089]
    },{
      name:"Lobby",
      frame:3,
      pos:[671.124,786.314]
    },{
      name:"Hall",
      frame:3,
      pos:[807.165,466.93]
    },{
      name:"BBQ2",
      frame:3,
      pos:[1052.19,217.248]
    },{
      name:"Gym",
      frame:3,
      pos:[1062.62,246.647]
    },{
      name:"JacuzziView",
      frame:3,
      pos:[1151.31,207.745]
    },{
      name:"Pet Zone",
      frame:3,
      pos:[1199.4,728.36]
    },{
      name:"Children's Pool",
      frame:3,
      pos:[1210.89,205.571]
    },{
      name:"Eco Terrace",
      frame:3,
      pos:[1335.6,208.885]
    },{
      name:"Solarium",
      frame:3,
      pos:[1333.47,202.843]
    },{
      name:"Infinity Pool",
      frame:3,
      pos:[1431.44,213.271]
    },
    ],
    [
    {
      name:"Yoga Deck",
      frame:4,
      pos:[553.228,562.734]
    },{
      name:"Children's Play",
      frame:4,
      pos:[618.056,549.005]
    },{
      name:"Coworking",
      frame:4,
      pos:[636.688,264.119]
    },{
      name:"Laundry",
      frame:4,
      pos:[686.997,268.769]
    },{
      name:"Lobby",
      frame:4,
      pos:[673.003,779.948]
    },{
      name:"Hall",
      frame:4,
      pos:[813.543,466.206]
    },{
      name:"BBQ2",
      frame:4,
      pos:[1045.27,216.456]
    },{
      name:"Gym",
      frame:4,
      pos:[1067.53,245.882]
    },{
      name:"JacuzziView",
      frame:4,
      pos:[1147.2,205.965]
    },{
      name:"Children's Pool",
      frame:4,
      pos:[1207.55,203.197]
    },{
      name:"Pet Zone",
      frame:4,
      pos:[1216.99,733.19]
    },{
      name:"Eco Terrace",
      frame:4,
      pos:[1335.35,205.372]
    },{
      name:"Solarium",
      frame:4,
      pos:[1340.28,199.19]
    },{
      name:"Infinity Pool",
      frame:4,
      pos:[1436.4,208.944]
    },
    ],
    [
    {
      name:"Yoga Deck",
      frame:5,
      pos:[569.833,558.747]
    },{
      name:"Coworking",
      frame:5,
      pos:[646.411,266.068]
    },{
      name:"Children's Play",
      frame:5,
      pos:[642.21,545.946]
    },{
      name:"Laundry",
      frame:5,
      pos:[706.013,270.316]
    },{
      name:"Lobby",
      frame:5,
      pos:[677.017,773.744]
    },{
      name:"Hall",
      frame:5,
      pos:[820.886,465.521]
    },{
      name:"BBQ2",
      frame:5,
      pos:[1037.58,215.724]
    },{
      name:"Gym",
      frame:5,
      pos:[1071.68,245.081]
    },{
      name:"JacuzziView",
      frame:5,
      pos:[1141.46,204.213]
    },{
      name:"Children's Pool",
      frame:5,
      pos:[1202.06,200.833]
    },{
      name:"Pet Zone",
      frame:5,
      pos:[1233.25,738.42]
    },{
      name:"Eco Terrace",
      frame:5,
      pos:[1331.92,201.803]
    },{
      name:"Solarium",
      frame:5,
      pos:[1344.33,195.406]
    },{
      name:"Infinity Pool",
      frame:5,
      pos:[1437.59,204.473]
    },
    ],
    [
    {
      name:"Yoga Deck",
      frame:6,
      pos:[588.489,555.018]
    },{
      name:"Coworking",
      frame:6,
      pos:[658.086,267.919]
    },{
      name:"Children's Play",
      frame:6,
      pos:[667.614,543.166]
    },{
      name:"Lobby",
      frame:6,
      pos:[683.04,767.744]
    },{
      name:"Laundry",
      frame:6,
      pos:[726.215,271.727]
    },{
      name:"Hall",
      frame:6,
      pos:[829.124,464.878]
    },{
      name:"BBQ2",
      frame:6,
      pos:[1029.17,215.061]
    },{
      name:"Gym",
      frame:6,
      pos:[1075.02,244.247]
    },{
      name:"JacuzziView",
      frame:6,
      pos:[1134.1,202.505]
    },{
      name:"Children's Pool",
      frame:6,
      pos:[1194.38,198.501]
    },{
      name:"Pet Zone",
      frame:6,
      pos:[1248.02,744.039]
    },{
      name:"Eco Terrace",
      frame:6,
      pos:[1325.14,198.209]
    },{
      name:"Solarium",
      frame:6,
      pos:[1345.39,191.516]
    },{
      name:"Infinity Pool",
      frame:6,
      pos:[1434.69,199.892]
    },
    ],
    [
    {
      name:"Yoga Deck",
      frame:7,
      pos:[608.966,551.552]
    },{
      name:"Coworking",
      frame:7,
      pos:[671.542,269.665]
    },{
      name:"Children's Play",
      frame:7,
      pos:[694.101,540.664]
    },{
      name:"Lobby",
      frame:7,
      pos:[690.937,761.981]
    },{
      name:"Laundry",
      frame:7,
      pos:[747.458,273.002]
    },{
      name:"Hall",
      frame:7,
      pos:[838.184,464.282]
    },{
      name:"BBQ2",
      frame:7,
      pos:[1020.12,214.473]
    },{
      name:"Gym",
      frame:7,
      pos:[1077.51,243.386]
    },{
      name:"JacuzziView",
      frame:7,
      pos:[1125.14,200.859]
    },{
      name:"Children's Pool",
      frame:7,
      pos:[1184.51,196.225]
    },{
      name:"Pet Zone",
      frame:7,
      pos:[1261.15,750.03]
    },{
      name:"Eco Terrace",
      frame:7,
      pos:[1314.87,194.628]
    },{
      name:"Solarium",
      frame:7,
      pos:[1343.26,187.549]
    },{
      name:"Infinity Pool",
      frame:7,
      pos:[1427.4,195.24]
    },
    ],
    [
    {
      name:"Yoga Deck",
      frame:8,
      pos:[631.049,548.353]
    },{
      name:"Coworking",
      frame:8,
      pos:[686.613,271.301]
    },{
      name:"Children's Play",
      frame:8,
      pos:[721.515,538.438]
    },{
      name:"Lobby",
      frame:8,
      pos:[700.572,756.485]
    },{
      name:"Laundry",
      frame:8,
      pos:[769.608,274.139]
    },{
      name:"Hall",
      frame:8,
      pos:[847.993,463.734]
    },{
      name:"BBQ2",
      frame:8,
      pos:[1010.49,213.966]
    },{
      name:"Gym",
      frame:8,
      pos:[1079.12,242.505]
    },{
      name:"JacuzziView",
      frame:8,
      pos:[1114.61,199.293]
    },{
      name:"Children's Pool",
      frame:8,
      pos:[1172.45,194.03]
    },{
      name:"Eco Terrace",
      frame:8,
      pos:[1301.02,191.097]
    },{
      name:"Pet Zone",
      frame:8,
      pos:[1272.48,756.373]
    },{
      name:"Solarium",
      frame:8,
      pos:[1337.75,183.537]
    },{
      name:"Infinity Pool",
      frame:8,
      pos:[1415.44,190.564]
    },
    ],
    [
    {
      name:"Yoga Deck",
      frame:9,
      pos:[654.54,545.422]
    },{
      name:"Coworking",
      frame:9,
      pos:[703.138,272.821]
    },{
      name:"Lobby",
      frame:9,
      pos:[711.808,751.281]
    },{
      name:"Children's Play",
      frame:9,
      pos:[749.718,536.483]
    },{
      name:"Laundry",
      frame:9,
      pos:[792.538,275.137]
    },{
      name:"Hall",
      frame:9,
      pos:[858.474,463.237]
    },{
      name:"BBQ2",
      frame:9,
      pos:[1000.39,213.546]
    },{
      name:"Gym",
      frame:9,
      pos:[1079.81,241.61]
    },{
      name:"JacuzziView",
      frame:9,
      pos:[1102.57,197.824]
    },{
      name:"Children's Pool",
      frame:9,
      pos:[1158.25,191.942]
    },{
      name:"Eco Terrace",
      frame:9,
      pos:[1283.53,187.662]
    },{
      name:"Solarium",
      frame:9,
      pos:[1328.7,179.519]
    },{
      name:"Pet Zone",
      frame:9,
      pos:[1281.81,763.042]
    },{
      name:"Infinity Pool",
      frame:9,
      pos:[1398.6,185.919]
    },
    ],
    [
    {
      name:"Yoga Deck",
      frame:10,
      pos:[679.26,542.759]
    },{
      name:"Coworking",
      frame:10,
      pos:[720.965,274.223]
    },{
      name:"Lobby",
      frame:10,
      pos:[724.509,746.391]
    },{
      name:"Children's Play",
      frame:10,
      pos:[778.582,534.799]
    },{
      name:"Laundry",
      frame:10,
      pos:[816.13,275.997]
    },{
      name:"Hall",
      frame:10,
      pos:[869.555,462.793]
    },{
      name:"BBQ2",
      frame:10,
      pos:[989.884,213.218]
    },{
      name:"Gym",
      frame:10,
      pos:[1079.57,240.706]
    },{
      name:"JacuzziView",
      frame:10,
      pos:[1089.12,196.47]
    },{
      name:"Children's Pool",
      frame:10,
      pos:[1142,189.987]
    },{
      name:"Eco Terrace",
      frame:10,
      pos:[1262.39,184.367]
    },{
      name:"Solarium",
      frame:10,
      pos:[1315.99,175.537]
    },{
      name:"Pet Zone",
      frame:10,
      pos:[1288.99,770.006]
    },{
      name:"Infinity Pool",
      frame:10,
      pos:[1376.72,181.365]
    },
    ],
    [
    {
      name:"Yoga Deck",
      frame:11,
      pos:[705.044,540.365]
    },{
      name:"Coworking",
      frame:11,
      pos:[739.949,275.503]
    },{
      name:"Lobby",
      frame:11,
      pos:[738.542,741.832]
    },{
      name:"Children's Play",
      frame:11,
      pos:[807.993,533.38]
    },{
      name:"Laundry",
      frame:11,
      pos:[840.273,276.718]
    },{
      name:"Hall",
      frame:11,
      pos:[881.159,462.405]
    },{
      name:"BBQ2",
      frame:11,
      pos:[979.086,212.985]
    },{
      name:"Gym",
      frame:11,
      pos:[1078.38,239.802]
    },{
      name:"JacuzziView",
      frame:11,
      pos:[1074.35,195.245]
    },{
      name:"Children's Pool",
      frame:11,
      pos:[1123.79,188.189]
    },{
      name:"Eco Terrace",
      frame:11,
      pos:[1237.7,181.26]
    },{
      name:"Solarium",
      frame:11,
      pos:[1299.52,171.64]
    },{
      name:"Infinity Pool",
      frame:11,
      pos:[1349.72,176.972]
    },{
      name:"Pet Zone",
      frame:11,
      pos:[1293.84,777.228]
    },
    ],
    [
    {
      name:"Yoga Deck",
      frame:12,
      pos:[731.743,538.235]
    },{
      name:"Coworking",
      frame:12,
      pos:[759.952,276.66]
    },{
      name:"Lobby",
      frame:12,
      pos:[753.777,737.617]
    },{
      name:"Children's Play",
      frame:12,
      pos:[837.845,532.226]
    },{
      name:"Laundry",
      frame:12,
      pos:[864.861,277.3]
    },{
      name:"Hall",
      frame:12,
      pos:[893.213,462.073]
    },{
      name:"BBQ2",
      frame:12,
      pos:[968.094,212.85]
    },{
      name:"Gym",
      frame:12,
      pos:[1076.22,238.905]
    },{
      name:"JacuzziView",
      frame:12,
      pos:[1058.39,194.167]
    },{
      name:"Children's Pool",
      frame:12,
      pos:[1103.77,186.574]
    },{
      name:"Eco Terrace",
      frame:12,
      pos:[1209.57,178.392]
    },{
      name:"Solarium",
      frame:12,
      pos:[1279.29,167.878]
    },{
      name:"Infinity Pool",
      frame:12,
      pos:[1317.63,172.812]
    },{
      name:"Pet Zone",
      frame:12,
      pos:[1296.19,784.664]
    },
    ],
    [
    {
      name:"Yoga Deck",
      frame:13,
      pos:[759.22,536.369]
    },{
      name:"Coworking",
      frame:13,
      pos:[780.847,277.692]
    },{
      name:"Lobby",
      frame:13,
      pos:[770.089,733.759]
    },{
      name:"Children's Play",
      frame:13,
      pos:[868.04,531.333]
    },{
      name:"Laundry",
      frame:13,
      pos:[889.794,277.744]
    },{
      name:"Hall",
      frame:13,
      pos:[905.64,461.799]
    },{
      name:"BBQ2",
      frame:13,
      pos:[957.011,212.814]
    },{
      name:"Gym",
      frame:13,
      pos:[1073.1,238.022]
    },{
      name:"JacuzziView",
      frame:13,
      pos:[1041.39,193.249]
    },{
      name:"Children's Pool",
      frame:13,
      pos:[1082.13,185.165]
    },{
      name:"Eco Terrace",
      frame:13,
      pos:[1178.24,175.811]
    },{
      name:"Solarium",
      frame:13,
      pos:[1255.32,164.306]
    },{
      name:"Infinity Pool",
      frame:13,
      pos:[1280.6,168.96]
    },{
      name:"Pet Zone",
      frame:13,
      pos:[1295.87,792.26]
    },
    ],
    [
    {
      name:"Yoga Deck",
      frame:14,
      pos:[787.351,534.764]
    },{
      name:"Coworking",
      frame:14,
      pos:[802.51,278.599]
    },{
      name:"Lobby",
      frame:14,
      pos:[787.356,730.266]
    },{
      name:"Children's Play",
      frame:14,
      pos:[898.485,530.699]
    },{
      name:"Hall",
      frame:14,
      pos:[918.367,461.584]
    },{
      name:"Laundry",
      frame:14,
      pos:[914.977,278.05]
    },{
      name:"BBQ2",
      frame:14,
      pos:[945.943,212.878]
    },{
      name:"JacuzziView",
      frame:14,
      pos:[1023.51,192.502]
    },{
      name:"Children's Pool",
      frame:14,
      pos:[1059.08,183.982]
    },{
      name:"Gym",
      frame:14,
      pos:[1069.03,237.162]
    },{
      name:"Eco Terrace",
      frame:14,
      pos:[1144,173.562]
    },{
      name:"Solarium",
      frame:14,
      pos:[1227.73,160.978]
    },{
      name:"Infinity Pool",
      frame:14,
      pos:[1238.91,165.492]
    },{
      name:"Pet Zone",
      frame:14,
      pos:[1292.74,799.959]
    },
    ],
    [
    {
      name:"Yoga Deck",
      frame:15,
      pos:[816.02,533.418]
    },{
      name:"Coworking",
      frame:15,
      pos:[824.825,279.379]
    },{
      name:"Lobby",
      frame:15,
      pos:[805.464,727.147]
    },{
      name:"BBQ2",
      frame:15,
      pos:[934.995,213.041]
    },{
      name:"Hall",
      frame:15,
      pos:[931.321,461.429]
    },{
      name:"Children's Play",
      frame:15,
      pos:[929.095,530.324]
    },{
      name:"Laundry",
      frame:15,
      pos:[940.315,278.218]
    },{
      name:"Children's Pool",
      frame:15,
      pos:[1034.86,183.044]
    },{
      name:"JacuzziView",
      frame:15,
      pos:[1004.93,191.938]
    },{
      name:"Gym",
      frame:15,
      pos:[1064.01,236.33]
    },{
      name:"Eco Terrace",
      frame:15,
      pos:[1107.24,171.688]
    },{
      name:"Infinity Pool",
      frame:15,
      pos:[1192.98,162.483]
    },{
      name:"Solarium",
      frame:15,
      pos:[1196.71,157.95]
    },{
      name:"Pet Zone",
      frame:15,
      pos:[1286.67,807.693]
    },
    ],
    [
    {
      name:"Coworking",
      frame:16,
      pos:[847.685,280.033]
    },{
      name:"Yoga Deck",
      frame:16,
      pos:[845.124,532.328]
    },{
      name:"Lobby",
      frame:16,
      pos:[824.3,724.405]
    },{
      name:"BBQ2",
      frame:16,
      pos:[924.272,213.302]
    },{
      name:"Hall",
      frame:16,
      pos:[944.426,461.333]
    },{
      name:"Children's Play",
      frame:16,
      pos:[959.783,530.205]
    },{
      name:"Laundry",
      frame:16,
      pos:[965.719,278.248]
    },{
      name:"Children's Pool",
      frame:16,
      pos:[1009.74,182.364]
    },{
      name:"JacuzziView",
      frame:16,
      pos:[985.856,191.564]
    },{
      name:"Eco Terrace",
      frame:16,
      pos:[1068.4,170.227]
    },{
      name:"Gym",
      frame:16,
      pos:[1058.09,235.537]
    },{
      name:"Infinity Pool",
      frame:16,
      pos:[1143.38,160.001]
    },{
      name:"Solarium",
      frame:16,
      pos:[1162.55,155.277]
    },{
      name:"Pet Zone",
      frame:16,
      pos:[1277.56,815.386]
    },
    ],
    [
    {
      name:"Lobby",
      frame:17,
      pos:[843.758,722.047]
    },{
      name:"Coworking",
      frame:17,
      pos:[870.986,280.561]
    },{
      name:"Yoga Deck",
      frame:17,
      pos:[874.562,531.493]
    },{
      name:"BBQ2",
      frame:17,
      pos:[913.873,213.656]
    },{
      name:"Hall",
      frame:17,
      pos:[957.611,461.298]
    },{
      name:"Children's Pool",
      frame:17,
      pos:[984.015,181.955]
    },{
      name:"JacuzziView",
      frame:17,
      pos:[966.484,191.385]
    },{
      name:"Laundry",
      frame:17,
      pos:[991.098,278.141]
    },{
      name:"Children's Play",
      frame:17,
      pos:[990.469,530.344]
    },{
      name:"Eco Terrace",
      frame:17,
      pos:[1028,169.207]
    },{
      name:"Gym",
      frame:17,
      pos:[1051.29,234.788]
    },{
      name:"Infinity Pool",
      frame:17,
      pos:[1090.78,158.105]
    },{
      name:"Solarium",
      frame:17,
      pos:[1125.59,153.008]
    },{
      name:"Pet Zone",
      frame:17,
      pos:[1265.33,822.957]
    },
    ],
    [
    {
      name:"Lobby",
      frame:18,
      pos:[863.736,720.074]
    },{
      name:"BBQ2",
      frame:18,
      pos:[903.894,214.102]
    },{
      name:"Coworking",
      frame:18,
      pos:[894.627,280.961]
    },{
      name:"Yoga Deck",
      frame:18,
      pos:[904.244,530.91]
    },{
      name:"Children's Pool",
      frame:18,
      pos:[957.985,181.822]
    },{
      name:"Eco Terrace",
      frame:18,
      pos:[986.59,168.651]
    },{
      name:"JacuzziView",
      frame:18,
      pos:[947.026,191.404]
    },{
      name:"Hall",
      frame:18,
      pos:[970.8,461.324]
    },{
      name:"Infinity Pool",
      frame:18,
      pos:[1035.99,156.842]
    },{
      name:"Laundry",
      frame:18,
      pos:[1016.36,277.895]
    },{
      name:"Children's Play",
      frame:18,
      pos:[1021.07,530.739]
    },{
      name:"Gym",
      frame:18,
      pos:[1043.66,234.093]
    },{
      name:"Solarium",
      frame:18,
      pos:[1086.3,151.189]
    },{
      name:"Pet Zone",
      frame:18,
      pos:[1249.95,830.316]
    },
    ],
    [
    {
      name:"BBQ2",
      frame:19,
      pos:[894.424,214.632]
    },{
      name:"Lobby",
      frame:19,
      pos:[884.135,718.489]
    },{
      name:"Children's Pool",
      frame:19,
      pos:[931.963,181.968]
    },{
      name:"Eco Terrace",
      frame:19,
      pos:[944.777,168.57]
    },{
      name:"Coworking",
      frame:19,
      pos:[918.514,281.235]
    },{
      name:"Yoga Deck",
      frame:19,
      pos:[934.081,530.579]
    },{
      name:"JacuzziView",
      frame:19,
      pos:[927.693,191.62]
    },{
      name:"Infinity Pool",
      frame:19,
      pos:[979.908,156.245]
    },{
      name:"Hall",
      frame:19,
      pos:[983.922,461.41]
    },{
      name:"Solarium",
      frame:19,
      pos:[1045.17,149.858]
    },{
      name:"Gym",
      frame:19,
      pos:[1035.26,233.457]
    },{
      name:"Laundry",
      frame:19,
      pos:[1041.41,277.512]
    },{
      name:"Children's Play",
      frame:19,
      pos:[1051.5,531.393]
    },{
      name:"Pet Zone",
      frame:19,
      pos:[1231.45,837.37]
    },
    ],
    [
    {
      name:"BBQ2",
      frame:20,
      pos:[885.547,215.243]
    },{
      name:"Eco Terrace",
      frame:20,
      pos:[903.165,168.966]
    },{
      name:"Children's Pool",
      frame:20,
      pos:[906.259,182.39]
    },{
      name:"Infinity Pool",
      frame:20,
      pos:[923.461,156.328]
    },{
      name:"JacuzziView",
      frame:20,
      pos:[908.697,192.031]
    },{
      name:"Lobby",
      frame:20,
      pos:[904.858,717.294]
    },{
      name:"Coworking",
      frame:20,
      pos:[942.552,281.383]
    },{
      name:"Yoga Deck",
      frame:20,
      pos:[963.986,530.499]
    },{
      name:"Solarium",
      frame:20,
      pos:[1002.78,149.041]
    },{
      name:"Hall",
      frame:20,
      pos:[996.903,461.557]
    },{
      name:"Gym",
      frame:20,
      pos:[1026.16,232.887]
    },{
      name:"Laundry",
      frame:20,
      pos:[1066.17,276.99]
    },{
      name:"Children's Play",
      frame:20,
      pos:[1081.67,532.306]
    },{
      name:"Pet Zone",
      frame:20,
      pos:[1209.88,844.022]
    },
    ],
    [
    {
      name:"Infinity Pool",
      frame:21,
      pos:[867.607,157.091]
    },{
      name:"Eco Terrace",
      frame:21,
      pos:[862.356,169.83]
    },{
      name:"Children's Pool",
      frame:21,
      pos:[881.177,183.082]
    },{
      name:"BBQ2",
      frame:21,
      pos:[877.337,215.926]
    },{
      name:"JacuzziView",
      frame:21,
      pos:[890.238,192.63]
    },{
      name:"Solarium",
      frame:21,
      pos:[959.737,148.758]
    },{
      name:"Lobby",
      frame:21,
      pos:[925.814,716.49]
    },{
      name:"Coworking",
      frame:21,
      pos:[966.651,281.404]
    },{
      name:"Yoga Deck",
      frame:21,
      pos:[993.877,530.67]
    },{
      name:"Gym",
      frame:21,
      pos:[1016.44,232.39]
    },{
      name:"Hall",
      frame:21,
      pos:[1009.67,461.763]
    },{
      name:"Laundry",
      frame:21,
      pos:[1090.52,276.33]
    },{
      name:"Children's Play",
      frame:21,
      pos:[1111.49,533.481]
    },{
      name:"Pet Zone",
      frame:21,
      pos:[1185.38,850.173]
    },
    ],
    [
    {
      name:"Infinity Pool",
      frame:22,
      pos:[813.279,158.513]
    },{
      name:"Eco Terrace",
      frame:22,
      pos:[822.924,171.144]
    },{
      name:"Children's Pool",
      frame:22,
      pos:[857.006,184.032]
    },{
      name:"BBQ2",
      frame:22,
      pos:[869.861,216.676]
    },{
      name:"JacuzziView",
      frame:22,
      pos:[872.511,193.409]
    },{
      name:"Solarium",
      frame:22,
      pos:[916.679,149.013]
    },{
      name:"Lobby",
      frame:22,
      pos:[946.909,716.078]
    },{
      name:"Coworking",
      frame:22,
      pos:[990.72,281.298]
    },{
      name:"Gym",
      frame:22,
      pos:[1006.17,231.971]
    },{
      name:"Hall",
      frame:22,
      pos:[1022.15,462.029]
    },{
      name:"Yoga Deck",
      frame:22,
      pos:[1023.67,531.091]
    },{
      name:"Laundry",
      frame:22,
      pos:[1114.36,275.531]
    },{
      name:"Children's Play",
      frame:22,
      pos:[1140.86,534.92]
    },{
      name:"Pet Zone",
      frame:22,
      pos:[1158.13,855.726]
    },
    ],
    [
    {
      name:"Infinity Pool",
      frame:23,
      pos:[761.345,160.557]
    },{
      name:"Eco Terrace",
      frame:23,
      pos:[785.401,172.881]
    },{
      name:"Children's Pool",
      frame:23,
      pos:[834.015,185.225]
    },{
      name:"Solarium",
      frame:23,
      pos:[874.238,149.801]
    },{
      name:"BBQ2",
      frame:23,
      pos:[863.174,217.484]
    },{
      name:"JacuzziView",
      frame:23,
      pos:[855.694,194.359]
    },{
      name:"Gym",
      frame:23,
      pos:[995.451,231.634]
    },{
      name:"Lobby",
      frame:23,
      pos:[968.054,716.057]
    },{
      name:"Coworking",
      frame:23,
      pos:[1014.67,281.066]
    },{
      name:"Hall",
      frame:23,
      pos:[1034.26,462.352]
    },{
      name:"Yoga Deck",
      frame:23,
      pos:[1053.27,531.765]
    },{
      name:"Pet Zone",
      frame:23,
      pos:[1128.39,860.591]
    },{
      name:"Laundry",
      frame:23,
      pos:[1137.6,274.594]
    },{
      name:"Children's Play",
      frame:23,
      pos:[1169.68,536.626]
    },
    ],
    [
    {
      name:"Infinity Pool",
      frame:24,
      pos:[712.581,163.174]
    },{
      name:"Eco Terrace",
      frame:24,
      pos:[750.261,175.007]
    },{
      name:"Children's Pool",
      frame:24,
      pos:[812.445,186.645]
    },{
      name:"Solarium",
      frame:24,
      pos:[833.027,151.106]
    },{
      name:"BBQ2",
      frame:24,
      pos:[857.324,218.343]
    },{
      name:"JacuzziView",
      frame:24,
      pos:[839.948,195.466]
    },{
      name:"Gym",
      frame:24,
      pos:[984.383,231.384]
    },{
      name:"Lobby",
      frame:24,
      pos:[989.158,716.429]
    },{
      name:"Coworking",
      frame:24,
      pos:[1038.4,280.707]
    },{
      name:"Hall",
      frame:24,
      pos:[1045.93,462.732]
    },{
      name:"Yoga Deck",
      frame:24,
      pos:[1082.6,532.692]
    },{
      name:"Pet Zone",
      frame:24,
      pos:[1096.46,864.68]
    },{
      name:"Laundry",
      frame:24,
      pos:[1160.11,273.518]
    },{
      name:"Children's Play",
      frame:24,
      pos:[1197.83,538.601]
    },
    ],
    [
    {
      name:"Infinity Pool",
      frame:25,
      pos:[667.647,166.302]
    },{
      name:"Eco Terrace",
      frame:25,
      pos:[717.906,177.481]
    },{
      name:"Solarium",
      frame:25,
      pos:[793.62,152.9]
    },{
      name:"Children's Pool",
      frame:25,
      pos:[792.509,188.269]
    },{
      name:"JacuzziView",
      frame:25,
      pos:[825.417,196.716]
    },{
      name:"BBQ2",
      frame:25,
      pos:[852.348,219.244]
    },{
      name:"Gym",
      frame:25,
      pos:[973.069,231.223]
    },{
      name:"Lobby",
      frame:25,
      pos:[1010.13,717.192]
    },{
      name:"Hall",
      frame:25,
      pos:[1057.1,463.168]
    },{
      name:"Pet Zone",
      frame:25,
      pos:[1062.72,867.922]
    },{
      name:"Coworking",
      frame:25,
      pos:[1061.82,280.222]
    },{
      name:"Yoga Deck",
      frame:25,
      pos:[1111.56,533.874]
    },{
      name:"Laundry",
      frame:25,
      pos:[1181.76,272.304]
    },{
      name:"Children's Play",
      frame:25,
      pos:[1225.17,540.849]
    },
    ],
    [
    {
      name:"Infinity Pool",
      frame:26,
      pos:[627.068,169.871]
    },{
      name:"Eco Terrace",
      frame:26,
      pos:[688.664,180.257]
    },{
      name:"Solarium",
      frame:26,
      pos:[756.532,155.145]
    },{
      name:"Children's Pool",
      frame:26,
      pos:[774.386,190.074]
    },{
      name:"JacuzziView",
      frame:26,
      pos:[812.223,198.094]
    },{
      name:"BBQ2",
      frame:26,
      pos:[848.274,220.178]
    },{
      name:"Gym",
      frame:26,
      pos:[961.615,231.153]
    },{
      name:"Pet Zone",
      frame:26,
      pos:[1027.59,870.254]
    },{
      name:"Lobby",
      frame:26,
      pos:[1030.88,718.345]
    },{
      name:"Hall",
      frame:26,
      pos:[1067.67,463.657]
    },{
      name:"Coworking",
      frame:26,
      pos:[1084.84,279.61]
    },{
      name:"Yoga Deck",
      frame:26,
      pos:[1140.05,535.314]
    },{
      name:"Laundry",
      frame:26,
      pos:[1202.44,270.952]
    },{
      name:"Children's Play",
      frame:26,
      pos:[1251.58,543.372]
    },
    ],
    [
    {
      name:"Infinity Pool",
      frame:27,
      pos:[591.228,173.806]
    },{
      name:"Eco Terrace",
      frame:27,
      pos:[662.781,183.288]
    },{
      name:"Solarium",
      frame:27,
      pos:[722.21,157.798]
    },{
      name:"Children's Pool",
      frame:27,
      pos:[758.221,192.036]
    },{
      name:"JacuzziView",
      frame:27,
      pos:[800.467,199.582]
    },{
      name:"BBQ2",
      frame:27,
      pos:[845.121,221.139]
    },{
      name:"Gym",
      frame:27,
      pos:[950.133,231.175]
    },{
      name:"Pet Zone",
      frame:27,
      pos:[991.522,871.632]
    },{
      name:"Lobby",
      frame:27,
      pos:[1051.32,719.889]
    },{
      name:"Hall",
      frame:27,
      pos:[1077.59,464.197]
    },{
      name:"Coworking",
      frame:27,
      pos:[1107.35,278.871]
    },{
      name:"Yoga Deck",
      frame:27,
      pos:[1167.96,537.012]
    },{
      name:"Laundry",
      frame:27,
      pos:[1221.99,269.464]
    },{
      name:"Children's Play",
      frame:27,
      pos:[1276.89,546.173]
    },
    ],
    [
    {
      name:"Infinity Pool",
      frame:28,
      pos:[560.377,178.03]
    },{
      name:"Eco Terrace",
      frame:28,
      pos:[640.427,186.524]
    },{
      name:"Solarium",
      frame:28,
      pos:[691.019,160.809]
    },{
      name:"Children's Pool",
      frame:28,
      pos:[744.123,194.13]
    },{
      name:"JacuzziView",
      frame:28,
      pos:[790.229,201.164]
    },{
      name:"BBQ2",
      frame:28,
      pos:[842.899,222.116]
    },{
      name:"Gym",
      frame:28,
      pos:[938.732,231.288]
    },{
      name:"Pet Zone",
      frame:28,
      pos:[955.004,872.03]
    },{
      name:"Lobby",
      frame:28,
      pos:[1071.35,721.821]
    },{
      name:"Hall",
      frame:28,
      pos:[1086.76,464.787]
    },{
      name:"Coworking",
      frame:28,
      pos:[1129.24,278.006]
    },{
      name:"Yoga Deck",
      frame:28,
      pos:[1195.17,538.973]
    },{
      name:"Laundry",
      frame:28,
      pos:[1240.28,267.842]
    },{
      name:"Children's Play",
      frame:28,
      pos:[1300.94,549.254]
    },
    ],
    [
    {
      name:"Infinity Pool",
      frame:29,
      pos:[534.631,182.469]
    },{
      name:"Eco Terrace",
      frame:29,
      pos:[621.694,189.917]
    },{
      name:"Solarium",
      frame:29,
      pos:[663.242,164.122]
    },{
      name:"Children's Pool",
      frame:29,
      pos:[732.166,196.329]
    },{
      name:"JacuzziView",
      frame:29,
      pos:[781.564,202.823]
    },{
      name:"BBQ2",
      frame:29,
      pos:[841.607,223.102]
    },{
      name:"Pet Zone",
      frame:29,
      pos:[918.536,871.439]
    },{
      name:"Gym",
      frame:29,
      pos:[927.521,231.492]
    },{
      name:"Hall",
      frame:29,
      pos:[1095.13,465.423]
    },{
      name:"Lobby",
      frame:29,
      pos:[1090.87,724.14]
    },{
      name:"Coworking",
      frame:29,
      pos:[1150.4,277.016]
    },{
      name:"Yoga Deck",
      frame:29,
      pos:[1221.55,541.198]
    },{
      name:"Laundry",
      frame:29,
      pos:[1257.13,266.089]
    },{
      name:"Children's Play",
      frame:29,
      pos:[1323.54,552.615]
    },
    ],
    [
    {
      name:"Infinity Pool",
      frame:30,
      pos:[513.992,187.051]
    },{
      name:"Eco Terrace",
      frame:30,
      pos:[606.607,193.421]
    },{
      name:"Solarium",
      frame:30,
      pos:[639.076,167.683]
    },{
      name:"Children's Pool",
      frame:30,
      pos:[722.394,198.608]
    },{
      name:"JacuzziView",
      frame:30,
      pos:[774.51,204.541]
    },{
      name:"BBQ2",
      frame:30,
      pos:[841.238,224.088]
    },{
      name:"Pet Zone",
      frame:30,
      pos:[882.614,869.871]
    },{
      name:"Gym",
      frame:30,
      pos:[916.606,231.783]
    },{
      name:"Hall",
      frame:30,
      pos:[1102.61,466.102]
    },{
      name:"Lobby",
      frame:30,
      pos:[1109.77,726.841]
    },{
      name:"Coworking",
      frame:30,
      pos:[1170.71,275.9]
    },{
      name:"Yoga Deck",
      frame:30,
      pos:[1246.97,543.689]
    },{
      name:"Laundry",
      frame:30,
      pos:[1272.39,264.208]
    },{
      name:"Children's Play",
      frame:30,
      pos:[1344.48,556.254]
    },
    ],
    [
    {
      name:"Infinity Pool",
      frame:31,
      pos:[498.366,191.709]
    },{
      name:"Eco Terrace",
      frame:31,
      pos:[595.132,196.99]
    },{
      name:"Solarium",
      frame:31,
      pos:[618.64,171.436]
    },{
      name:"Children's Pool",
      frame:31,
      pos:[714.82,200.942]
    },{
      name:"JacuzziView",
      frame:31,
      pos:[769.083,206.299]
    },{
      name:"BBQ2",
      frame:31,
      pos:[841.779,225.068]
    },{
      name:"Pet Zone",
      frame:31,
      pos:[847.72,867.356]
    },{
      name:"Gym",
      frame:31,
      pos:[906.089,232.159]
    },{
      name:"Hall",
      frame:31,
      pos:[1109.13,466.82]
    },{
      name:"Lobby",
      frame:31,
      pos:[1127.96,729.921]
    },{
      name:"Coworking",
      frame:31,
      pos:[1190.05,274.66]
    },{
      name:"Yoga Deck",
      frame:31,
      pos:[1271.27,546.448]
    },{
      name:"Laundry",
      frame:31,
      pos:[1285.88,262.204]
    },{
      name:"Children's Play",
      frame:31,
      pos:[1363.53,560.169]
    },
    ],
    [
    {
      name:"Infinity Pool",
      frame:32,
      pos:[487.576,196.384]
    },{
      name:"Eco Terrace",
      frame:32,
      pos:[587.183,200.583]
    },{
      name:"Solarium",
      frame:32,
      pos:[601.977,175.328]
    },{
      name:"Children's Pool",
      frame:32,
      pos:[709.429,203.307]
    },{
      name:"JacuzziView",
      frame:32,
      pos:[765.282,208.083]
    },{
      name:"Pet Zone",
      frame:32,
      pos:[814.306,863.943]
    },{
      name:"BBQ2",
      frame:32,
      pos:[843.206,226.033]
    },{
      name:"Gym",
      frame:32,
      pos:[896.067,232.616]
    },{
      name:"Hall",
      frame:32,
      pos:[1114.64,467.575]
    },{
      name:"Lobby",
      frame:32,
      pos:[1145.32,733.375]
    },{
      name:"Coworking",
      frame:32,
      pos:[1208.28,273.299]
    },{
      name:"Laundry",
      frame:32,
      pos:[1297.4,260.085]
    },{
      name:"Yoga Deck",
      frame:32,
      pos:[1294.27,549.476]
    },{
      name:"Children's Play",
      frame:32,
      pos:[1380.46,564.354]
    },
    ],
    [
    {
      name:"Infinity Pool",
      frame:33,
      pos:[481.385,201.023]
    },{
      name:"Eco Terrace",
      frame:33,
      pos:[582.631,204.164]
    },{
      name:"Solarium",
      frame:33,
      pos:[589.063,179.306]
    },{
      name:"Children's Pool",
      frame:33,
      pos:[706.183,205.681]
    },{
      name:"JacuzziView",
      frame:33,
      pos:[763.089,209.876]
    },{
      name:"Pet Zone",
      frame:33,
      pos:[782.781,859.695]
    },{
      name:"BBQ2",
      frame:33,
      pos:[845.494,226.977]
    },{
      name:"Gym",
      frame:33,
      pos:[886.626,233.148]
    },{
      name:"Hall",
      frame:33,
      pos:[1119.05,468.36]
    },{
      name:"Lobby",
      frame:33,
      pos:[1161.74,737.195]
    },{
      name:"Coworking",
      frame:33,
      pos:[1225.25,271.818]
    },{
      name:"Laundry",
      frame:33,
      pos:[1306.78,257.858]
    },{
      name:"Yoga Deck",
      frame:33,
      pos:[1315.8,552.772]
    },{
      name:"Children's Play",
      frame:33,
      pos:[1394.99,568.8]
    },
    ],
    [
    {
      name:"Infinity Pool",
      frame:34,
      pos:[479.514,205.58]
    },{
      name:"Solarium",
      frame:34,
      pos:[579.822,183.323]
    },{
      name:"Eco Terrace",
      frame:34,
      pos:[581.32,207.7]
    },{
      name:"Children's Pool",
      frame:34,
      pos:[705.024,208.043]
    },{
      name:"Pet Zone",
      frame:34,
      pos:[753.505,854.689]
    },{
      name:"JacuzziView",
      frame:34,
      pos:[762.473,211.662]
    },{
      name:"BBQ2",
      frame:34,
      pos:[848.608,227.893]
    },{
      name:"Gym",
      frame:34,
      pos:[877.85,233.75]
    },{
      name:"Hall",
      frame:34,
      pos:[1122.31,469.171]
    },{
      name:"Lobby",
      frame:34,
      pos:[1177.09,741.373]
    },{
      name:"Coworking",
      frame:34,
      pos:[1240.82,270.22]
    },{
      name:"Laundry",
      frame:34,
      pos:[1313.8,255.535]
    },{
      name:"Yoga Deck",
      frame:34,
      pos:[1335.64,556.333]
    },{
      name:"Children's Play",
      frame:34,
      pos:[1406.85,573.493]
    },
    ],
    [
    {
      name:"Infinity Pool",
      frame:35,
      pos:[481.657,210.018]
    },{
      name:"Solarium",
      frame:35,
      pos:[574.129,187.336]
    },{
      name:"Eco Terrace",
      frame:35,
      pos:[583.066,211.161]
    },{
      name:"Children's Pool",
      frame:35,
      pos:[705.877,210.374]
    },{
      name:"Pet Zone",
      frame:35,
      pos:[726.777,849.01]
    },{
      name:"JacuzziView",
      frame:35,
      pos:[763.387,213.428]
    },{
      name:"BBQ2",
      frame:35,
      pos:[852.512,228.774]
    },{
      name:"Gym",
      frame:35,
      pos:[869.81,234.415]
    },{
      name:"Hall",
      frame:35,
      pos:[1124.37,470.003]
    },{
      name:"Lobby",
      frame:35,
      pos:[1191.26,745.897]
    },{
      name:"Coworking",
      frame:35,
      pos:[1254.83,268.51]
    },{
      name:"Laundry",
      frame:35,
      pos:[1318.3,253.127]
    },{
      name:"Yoga Deck",
      frame:35,
      pos:[1353.59,560.156]
    },{
      name:"Children's Play",
      frame:35,
      pos:[1415.75,578.416]
    },
    ],
    [
    {
      name:"Infinity Pool",
      frame:36,
      pos:[487.491,214.306]
    },{
      name:"Solarium",
      frame:36,
      pos:[571.823,191.307]
    },{
      name:"Eco Terrace",
      frame:36,
      pos:[587.672,214.523]
    },{
      name:"Pet Zone",
      frame:36,
      pos:[702.838,842.754]
    },{
      name:"Children's Pool",
      frame:36,
      pos:[708.652,212.657]
    },{
      name:"JacuzziView",
      frame:36,
      pos:[765.777,215.16]
    },{
      name:"BBQ2",
      frame:36,
      pos:[857.164,229.616]
    },{
      name:"Gym",
      frame:36,
      pos:[862.568,235.137]
    },{
      name:"Hall",
      frame:36,
      pos:[1125.18,470.85]
    },{
      name:"Lobby",
      frame:36,
      pos:[1204.11,750.753]
    },{
      name:"Coworking",
      frame:36,
      pos:[1267.11,266.692]
    },{
      name:"Laundry",
      frame:36,
      pos:[1320.06,250.649]
    },{
      name:"Yoga Deck",
      frame:36,
      pos:[1369.39,564.234]
    },{
      name:"Children's Play",
      frame:36,
      pos:[1421.38,583.545]
    },
    ],
    [
    {
      name:"Infinity Pool",
      frame:37,
      pos:[496.691,218.419]
    },{
      name:"Solarium",
      frame:37,
      pos:[572.718,195.202]
    },{
      name:"Eco Terrace",
      frame:37,
      pos:[594.932,217.766]
    },{
      name:"Pet Zone",
      frame:37,
      pos:[681.862,836.015]
    },{
      name:"Children's Pool",
      frame:37,
      pos:[713.252,214.875]
    },{
      name:"JacuzziView",
      frame:37,
      pos:[769.579,216.847]
    },{
      name:"Gym",
      frame:37,
      pos:[856.177,235.907]
    },{
      name:"BBQ2",
      frame:37,
      pos:[862.519,230.413]
    },{
      name:"Hall",
      frame:37,
      pos:[1124.69,471.706]
    },{
      name:"Lobby",
      frame:37,
      pos:[1215.5,755.925]
    },{
      name:"Coworking",
      frame:37,
      pos:[1277.5,264.775]
    },{
      name:"Laundry",
      frame:37,
      pos:[1318.9,248.12]
    },{
      name:"Yoga Deck",
      frame:37,
      pos:[1382.8,568.555]
    },{
      name:"Children's Play",
      frame:37,
      pos:[1423.43,588.849]
    },
    ],
    [
    {
      name:"Infinity Pool",
      frame:38,
      pos:[508.936,222.336]
    },{
      name:"Solarium",
      frame:38,
      pos:[576.611,198.992]
    },{
      name:"Eco Terrace",
      frame:38,
      pos:[604.636,220.871]
    },{
      name:"Pet Zone",
      frame:38,
      pos:[663.965,828.894]
    },{
      name:"Children's Pool",
      frame:38,
      pos:[719.569,217.016]
    },{
      name:"JacuzziView",
      frame:38,
      pos:[774.721,218.478]
    },{
      name:"Gym",
      frame:38,
      pos:[850.679,236.72]
    },{
      name:"BBQ2",
      frame:38,
      pos:[868.528,231.16]
    },{
      name:"Hall",
      frame:38,
      pos:[1122.87,472.563]
    },{
      name:"Lobby",
      frame:38,
      pos:[1225.31,761.391]
    },{
      name:"Coworking",
      frame:38,
      pos:[1285.82,262.766]
    },{
      name:"Laundry",
      frame:38,
      pos:[1314.67,245.56]
    },{
      name:"Yoga Deck",
      frame:38,
      pos:[1393.55,573.106]
    },{
      name:"Children's Play",
      frame:38,
      pos:[1421.61,594.292]
    },
    ],
    [
    {
      name:"Infinity Pool",
      frame:39,
      pos:[523.919,226.044]
    },{
      name:"Solarium",
      frame:39,
      pos:[583.286,202.652]
    },{
      name:"Eco Terrace",
      frame:39,
      pos:[616.575,223.824]
    },{
      name:"Pet Zone",
      frame:39,
      pos:[649.206,821.486]
    },{
      name:"Children's Pool",
      frame:39,
      pos:[727.493,219.066]
    },{
      name:"JacuzziView",
      frame:39,
      pos:[781.126,220.042]
    },{
      name:"Gym",
      frame:39,
      pos:[846.107,237.566]
    },{
      name:"BBQ2",
      frame:39,
      pos:[875.141,231.852]
    },{
      name:"Hall",
      frame:39,
      pos:[1119.7,473.415]
    },{
      name:"Lobby",
      frame:39,
      pos:[1233.4,767.127]
    },{
      name:"Coworking",
      frame:39,
      pos:[1291.9,260.674]
    },{
      name:"Laundry",
      frame:39,
      pos:[1307.22,242.991]
    },{
      name:"Yoga Deck",
      frame:39,
      pos:[1401.37,577.867]
    },{
      name:"Children's Play",
      frame:39,
      pos:[1415.63,599.827]
    },
    ],
    [
    {
      name:"Infinity Pool",
      frame:40,
      pos:[541.346,229.532]
    },{
      name:"Solarium",
      frame:40,
      pos:[592.525,206.162]
    },{
      name:"Eco Terrace",
      frame:40,
      pos:[630.546,226.615]
    },{
      name:"Pet Zone",
      frame:40,
      pos:[637.591,813.884]
    },{
      name:"Children's Pool",
      frame:40,
      pos:[736.909,221.016]
    },{
      name:"JacuzziView",
      frame:40,
      pos:[788.714,221.531]
    },{
      name:"Gym",
      frame:40,
      pos:[842.482,238.438]
    },{
      name:"BBQ2",
      frame:40,
      pos:[882.306,232.487]
    },{
      name:"Hall",
      frame:40,
      pos:[1115.18,474.254]
    },{
      name:"Lobby",
      frame:40,
      pos:[1239.62,773.104]
    },{
      name:"Laundry",
      frame:40,
      pos:[1296.43,240.441]
    },{
      name:"Coworking",
      frame:40,
      pos:[1295.56,258.513]
    },{
      name:"Children's Play",
      frame:40,
      pos:[1405.22,605.401]
    },{
      name:"Yoga Deck",
      frame:40,
      pos:[1405.95,582.814]
    },
    ],
    [
    {
      name:"Infinity Pool",
      frame:41,
      pos:[560.944,232.793]
    },{
      name:"Solarium",
      frame:41,
      pos:[604.11,209.506]
    },{
      name:"Pet Zone",
      frame:41,
      pos:[629.08,806.177]
    },{
      name:"Eco Terrace",
      frame:41,
      pos:[646.354,229.234]
    },{
      name:"Children's Pool",
      frame:41,
      pos:[747.701,222.857]
    },{
      name:"JacuzziView",
      frame:41,
      pos:[797.401,222.937]
    },{
      name:"Gym",
      frame:41,
      pos:[839.819,239.329]
    },{
      name:"BBQ2",
      frame:41,
      pos:[889.968,233.061]
    },{
      name:"Hall",
      frame:41,
      pos:[1109.3,475.073]
    },{
      name:"Lobby",
      frame:41,
      pos:[1243.85,779.288]
    },{
      name:"Laundry",
      frame:41,
      pos:[1282.23,237.938]
    },{
      name:"Coworking",
      frame:41,
      pos:[1296.63,256.296]
    },{
      name:"Children's Play",
      frame:41,
      pos:[1390.17,610.953]
    },{
      name:"Yoga Deck",
      frame:41,
      pos:[1407.03,587.916]
    },
    ],
    [
    {
      name:"Infinity Pool",
      frame:42,
      pos:[582.457,235.823]
    },{
      name:"Solarium",
      frame:42,
      pos:[617.829,212.671]
    },{
      name:"Pet Zone",
      frame:42,
      pos:[623.597,798.444]
    },{
      name:"Eco Terrace",
      frame:42,
      pos:[663.81,231.675]
    },{
      name:"Children's Pool",
      frame:42,
      pos:[759.753,224.58]
    },{
      name:"JacuzziView",
      frame:42,
      pos:[807.102,224.253]
    },{
      name:"Gym",
      frame:42,
      pos:[838.119,240.23]
    },{
      name:"BBQ2",
      frame:42,
      pos:[898.072,233.57]
    },{
      name:"Hall",
      frame:42,
      pos:[1102.09,475.864]
    },{
      name:"Lobby",
      frame:42,
      pos:[1245.96,785.64]
    },{
      name:"Laundry",
      frame:42,
      pos:[1264.59,235.513]
    },{
      name:"Coworking",
      frame:42,
      pos:[1294.97,254.04]
    },{
      name:"Children's Play",
      frame:42,
      pos:[1370.31,616.411]
    },{
      name:"Yoga Deck",
      frame:42,
      pos:[1404.31,593.135]
    },
    ],
    [
    {
      name:"Infinity Pool",
      frame:43,
      pos:[605.654,238.62]
    },{
      name:"Pet Zone",
      frame:43,
      pos:[621.031,790.76]
    },{
      name:"Solarium",
      frame:43,
      pos:[633.475,215.646]
    },{
      name:"Eco Terrace",
      frame:43,
      pos:[682.739,233.933]
    },{
      name:"Children's Pool",
      frame:43,
      pos:[772.952,226.18]
    },{
      name:"JacuzziView",
      frame:43,
      pos:[817.729,225.474]
    },{
      name:"Gym",
      frame:43,
      pos:[837.378,241.135]
    },{
      name:"BBQ2",
      frame:43,
      pos:[906.561,234.013]
    },{
      name:"Hall",
      frame:43,
      pos:[1093.58,476.618]
    },{
      name:"Laundry",
      frame:43,
      pos:[1243.52,233.199]
    },{
      name:"Lobby",
      frame:43,
      pos:[1245.83,792.114]
    },{
      name:"Coworking",
      frame:43,
      pos:[1290.43,251.762]
    },{
      name:"Children's Play",
      frame:43,
      pos:[1345.57,621.698]
    },{
      name:"Yoga Deck",
      frame:43,
      pos:[1397.55,598.426]
    },
    ],
    [
    {
      name:"Pet Zone",
      frame:44,
      pos:[621.249,783.191]
    },{
      name:"Infinity Pool",
      frame:44,
      pos:[630.321,241.183]
    },{
      name:"Solarium",
      frame:44,
      pos:[650.853,218.423]
    },{
      name:"Eco Terrace",
      frame:44,
      pos:[702.974,236.005]
    },{
      name:"Children's Pool",
      frame:44,
      pos:[787.185,227.651]
    },{
      name:"JacuzziView",
      frame:44,
      pos:[829.198,226.593]
    },{
      name:"Gym",
      frame:44,
      pos:[837.584,242.035]
    },{
      name:"BBQ2",
      frame:44,
      pos:[915.379,234.386]
    },{
      name:"Hall",
      frame:44,
      pos:[1083.82,477.328]
    },{
      name:"Laundry",
      frame:44,
      pos:[1219.14,231.029]
    },{
      name:"Lobby",
      frame:44,
      pos:[1243.35,798.662]
    },{
      name:"Coworking",
      frame:44,
      pos:[1282.89,249.485]
    },{
      name:"Children's Play",
      frame:44,
      pos:[1315.95,626.732]
    },{
      name:"Yoga Deck",
      frame:44,
      pos:[1386.51,603.737]
    },
    ],
    [
    {
      name:"Pet Zone",
      frame:45,
      pos:[624.099,775.794]
    },{
      name:"Infinity Pool",
      frame:45,
      pos:[656.264,243.513]
    },{
      name:"Solarium",
      frame:45,
      pos:[669.776,220.998]
    },{
      name:"Eco Terrace",
      frame:45,
      pos:[724.359,237.887]
    },{
      name:"Children's Pool",
      frame:45,
      pos:[802.343,228.987]
    },{
      name:"JacuzziView",
      frame:45,
      pos:[841.419,227.607]
    },{
      name:"Gym",
      frame:45,
      pos:[838.714,242.925]
    },{
      name:"BBQ2",
      frame:45,
      pos:[924.466,234.688]
    },{
      name:"Hall",
      frame:45,
      pos:[1072.87,477.985]
    },{
      name:"Laundry",
      frame:45,
      pos:[1191.57,229.037]
    },{
      name:"Lobby",
      frame:45,
      pos:[1238.43,805.226]
    },{
      name:"Coworking",
      frame:45,
      pos:[1272.26,247.232]
    },{
      name:"Children's Play",
      frame:45,
      pos:[1281.56,631.423]
    },{
      name:"Yoga Deck",
      frame:45,
      pos:[1371,609.008]
    },
    ],
    [
    {
      name:"Pet Zone",
      frame:46,
      pos:[629.419,768.619]
    },{
      name:"Infinity Pool",
      frame:46,
      pos:[683.311,245.613]
    },{
      name:"Solarium",
      frame:46,
      pos:[690.072,223.365]
    },{
      name:"Eco Terrace",
      frame:46,
      pos:[746.75,239.58]
    },{
      name:"Children's Pool",
      frame:46,
      pos:[818.319,230.187]
    },{
      name:"Gym",
      frame:46,
      pos:[840.745,243.797]
    },{
      name:"JacuzziView",
      frame:46,
      pos:[854.309,228.513]
    },{
      name:"BBQ2",
      frame:46,
      pos:[933.767,234.919]
    },{
      name:"Hall",
      frame:46,
      pos:[1060.82,478.584]
    },{
      name:"Laundry",
      frame:46,
      pos:[1161.07,227.257]
    },{
      name:"Lobby",
      frame:46,
      pos:[1231,811.746]
    },{
      name:"Children's Play",
      frame:46,
      pos:[1242.64,635.683]
    },{
      name:"Coworking",
      frame:46,
      pos:[1258.49,245.027]
    },{
      name:"Yoga Deck",
      frame:46,
      pos:[1350.91,614.171]
    },
    ],
    [
    {
      name:"Pet Zone",
      frame:47,
      pos:[637.036,761.71]
    },{
      name:"Infinity Pool",
      frame:47,
      pos:[711.302,247.484]
    },{
      name:"Solarium",
      frame:47,
      pos:[711.578,225.523]
    },{
      name:"Eco Terrace",
      frame:47,
      pos:[770.011,241.082]
    },{
      name:"Children's Pool",
      frame:47,
      pos:[835.011,231.246]
    },{
      name:"Gym",
      frame:47,
      pos:[843.642,244.645]
    },{
      name:"JacuzziView",
      frame:47,
      pos:[867.782,229.305]
    },{
      name:"BBQ2",
      frame:47,
      pos:[943.22,235.075]
    },{
      name:"Hall",
      frame:47,
      pos:[1047.77,479.116]
    },{
      name:"Laundry",
      frame:47,
      pos:[1127.93,225.721]
    },{
      name:"Children's Play",
      frame:47,
      pos:[1199.56,639.426]
    },{
      name:"Lobby",
      frame:47,
      pos:[1221.03,818.155]
    },{
      name:"Coworking",
      frame:47,
      pos:[1241.58,242.897]
    },{
      name:"Yoga Deck",
      frame:47,
      pos:[1326.16,619.151]
    },
    ],
    [
    {
      name:"Pet Zone",
      frame:48,
      pos:[646.775,755.103]
    },{
      name:"Solarium",
      frame:48,
      pos:[734.143,227.47]
    },{
      name:"Infinity Pool",
      frame:48,
      pos:[740.094,249.129]
    },{
      name:"Eco Terrace",
      frame:48,
      pos:[794.017,242.393]
    },{
      name:"Gym",
      frame:48,
      pos:[847.368,245.465]
    },{
      name:"Children's Pool",
      frame:48,
      pos:[852.318,232.163]
    },{
      name:"JacuzziView",
      frame:48,
      pos:[881.753,229.983]
    },{
      name:"BBQ2",
      frame:48,
      pos:[952.768,235.158]
    },{
      name:"Hall",
      frame:48,
      pos:[1033.83,479.575]
    },{
      name:"Laundry",
      frame:48,
      pos:[1092.51,224.456]
    },{
      name:"Children's Play",
      frame:48,
      pos:[1152.8,642.569]
    },{
      name:"Lobby",
      frame:48,
      pos:[1208.48,824.383]
    },{
      name:"Coworking",
      frame:48,
      pos:[1221.56,240.871]
    },{
      name:"Yoga Deck",
      frame:48,
      pos:[1296.8,623.871]
    },
    ],
    [
    {
      name:"Pet Zone",
      frame:49,
      pos:[658.464,748.827]
    },{
      name:"Solarium",
      frame:49,
      pos:[757.626,229.205]
    },{
      name:"Infinity Pool",
      frame:49,
      pos:[769.561,250.551]
    },{
      name:"Eco Terrace",
      frame:49,
      pos:[818.65,243.513]
    },{
      name:"Gym",
      frame:49,
      pos:[851.882,246.249]
    },{
      name:"Children's Pool",
      frame:49,
      pos:[870.142,232.934]
    },{
      name:"JacuzziView",
      frame:49,
      pos:[896.14,230.544]
    },{
      name:"BBQ2",
      frame:49,
      pos:[962.352,235.166]
    },{
      name:"Hall",
      frame:49,
      pos:[1019.13,479.956]
    },{
      name:"Laundry",
      frame:49,
      pos:[1055.25,223.487]
    },{
      name:"Children's Play",
      frame:49,
      pos:[1102.99,645.041]
    },{
      name:"Lobby",
      frame:49,
      pos:[1193.4,830.357]
    },{
      name:"Coworking",
      frame:49,
      pos:[1198.53,238.978]
    },{
      name:"Yoga Deck",
      frame:49,
      pos:[1262.97,628.249]
    },
    ],
    [
    {
      name:"Pet Zone",
      frame:50,
      pos:[671.93,742.907]
    },{
      name:"Solarium",
      frame:50,
      pos:[781.898,230.729]
    },{
      name:"Infinity Pool",
      frame:50,
      pos:[799.585,251.753]
    },{
      name:"Eco Terrace",
      frame:50,
      pos:[843.8,244.443]
    },{
      name:"Gym",
      frame:50,
      pos:[857.137,246.994]
    },{
      name:"Children's Pool",
      frame:50,
      pos:[888.39,233.56]
    },{
      name:"JacuzziView",
      frame:50,
      pos:[910.861,230.986]
    },{
      name:"BBQ2",
      frame:50,
      pos:[971.913,235.099]
    },{
      name:"Hall",
      frame:50,
      pos:[1003.82,480.254]
    },{
      name:"Laundry",
      frame:50,
      pos:[1016.65,222.833]
    },{
      name:"Children's Play",
      frame:50,
      pos:[1050.84,646.783]
    },{
      name:"Coworking",
      frame:50,
      pos:[1172.64,237.247]
    },{
      name:"Lobby",
      frame:50,
      pos:[1175.84,836.001]
    },{
      name:"Yoga Deck",
      frame:50,
      pos:[1224.91,632.203]
    },
    ],
    [
    {
      name:"Pet Zone",
      frame:51,
      pos:[687.009,737.363]
    },{
      name:"Solarium",
      frame:51,
      pos:[806.837,232.041]
    },{
      name:"Infinity Pool",
      frame:51,
      pos:[830.06,252.738]
    },{
      name:"Gym",
      frame:51,
      pos:[863.085,247.695]
    },{
      name:"Eco Terrace",
      frame:51,
      pos:[869.363,245.183]
    },{
      name:"Children's Pool",
      frame:51,
      pos:[906.968,234.039]
    },{
      name:"JacuzziView",
      frame:51,
      pos:[925.834,231.309]
    },{
      name:"Laundry",
      frame:51,
      pos:[977.223,222.508]
    },{
      name:"BBQ2",
      frame:51,
      pos:[981.391,234.958]
    },{
      name:"Hall",
      frame:51,
      pos:[988.041,480.464]
    },{
      name:"Children's Play",
      frame:51,
      pos:[997.189,647.75]
    },{
      name:"Coworking",
      frame:51,
      pos:[1144.12,235.705]
    },{
      name:"Lobby",
      frame:51,
      pos:[1155.91,841.238]
    },{
      name:"Yoga Deck",
      frame:51,
      pos:[1183,635.652]
    },
    ],
    [
    {
      name:"Pet Zone",
      frame:52,
      pos:[703.54,732.21]
    },{
      name:"Solarium",
      frame:52,
      pos:[832.331,233.143]
    },{
      name:"Infinity Pool",
      frame:52,
      pos:[860.887,253.507]
    },{
      name:"Gym",
      frame:52,
      pos:[869.675,248.349]
    },{
      name:"Eco Terrace",
      frame:52,
      pos:[895.241,245.734]
    },{
      name:"Children's Pool",
      frame:52,
      pos:[925.788,234.37]
    },{
      name:"Laundry",
      frame:52,
      pos:[937.535,222.518]
    },{
      name:"JacuzziView",
      frame:52,
      pos:[940.98,231.51]
    },{
      name:"Children's Play",
      frame:52,
      pos:[942.895,647.92]
    },{
      name:"Hall",
      frame:52,
      pos:[971.958,480.585]
    },{
      name:"BBQ2",
      frame:52,
      pos:[990.729,234.744]
    },{
      name:"Coworking",
      frame:52,
      pos:[1113.25,234.378]
    },{
      name:"Lobby",
      frame:52,
      pos:[1133.75,845.995]
    },{
      name:"Yoga Deck",
      frame:52,
      pos:[1137.73,638.524]
    },
    ],
    [
    {
      name:"Pet Zone",
      frame:53,
      pos:[721.37,727.461]
    },{
      name:"Solarium",
      frame:53,
      pos:[858.272,234.034]
    },{
      name:"Gym",
      frame:53,
      pos:[876.853,248.95]
    },{
      name:"Children's Play",
      frame:53,
      pos:[888.861,647.288]
    },{
      name:"Infinity Pool",
      frame:53,
      pos:[891.975,254.063]
    },{
      name:"Laundry",
      frame:53,
      pos:[898.146,222.864]
    },{
      name:"Eco Terrace",
      frame:53,
      pos:[921.339,246.096]
    },{
      name:"Children's Pool",
      frame:53,
      pos:[944.758,234.552]
    },{
      name:"JacuzziView",
      frame:53,
      pos:[956.217,231.59]
    },{
      name:"Hall",
      frame:53,
      pos:[955.737,480.615]
    },{
      name:"BBQ2",
      frame:53,
      pos:[999.868,234.457]
    },{
      name:"Coworking",
      frame:53,
      pos:[1080.36,233.292]
    },{
      name:"Yoga Deck",
      frame:53,
      pos:[1089.68,640.753]
    },{
      name:"Lobby",
      frame:53,
      pos:[1109.56,850.2]
    },
    ],
    [
    {
      name:"Pet Zone",
      frame:54,
      pos:[740.354,723.123]
    },{
      name:"Children's Play",
      frame:54,
      pos:[835.977,645.869]
    },{
      name:"Laundry",
      frame:54,
      pos:[859.608,223.537]
    },{
      name:"Solarium",
      frame:54,
      pos:[884.562,234.717]
    },{
      name:"Gym",
      frame:54,
      pos:[884.564,249.496]
    },{
      name:"Infinity Pool",
      frame:54,
      pos:[923.237,254.407]
    },{
      name:"Hall",
      frame:54,
      pos:[939.545,480.553]
    },{
      name:"Eco Terrace",
      frame:54,
      pos:[947.565,246.269]
    },{
      name:"Children's Pool",
      frame:54,
      pos:[963.793,234.586]
    },{
      name:"JacuzziView",
      frame:54,
      pos:[971.467,231.548]
    },{
      name:"BBQ2",
      frame:54,
      pos:[1008.75,234.099]
    },{
      name:"Yoga Deck",
      frame:54,
      pos:[1039.56,642.288]
    },{
      name:"Coworking",
      frame:54,
      pos:[1045.86,232.464]
    },{
      name:"Lobby",
      frame:54,
      pos:[1083.57,853.787]
    },
    ],
    [
    {
      name:"Pet Zone",
      frame:55,
      pos:[760.357,719.203]
    },{
      name:"Children's Play",
      frame:55,
      pos:[785.086,643.699]
    },{
      name:"Laundry",
      frame:55,
      pos:[822.452,224.525]
    },{
      name:"Gym",
      frame:55,
      pos:[892.75,249.985]
    },{
      name:"Solarium",
      frame:55,
      pos:[911.103,235.19]
    },{
      name:"Hall",
      frame:55,
      pos:[923.551,480.4]
    },{
      name:"Infinity Pool",
      frame:55,
      pos:[954.591,254.539]
    },{
      name:"Eco Terrace",
      frame:55,
      pos:[973.828,246.254]
    },{
      name:"Children's Pool",
      frame:55,
      pos:[982.803,234.471]
    },{
      name:"JacuzziView",
      frame:55,
      pos:[986.65,231.384]
    },{
      name:"Yoga Deck",
      frame:55,
      pos:[988.146,643.092]
    },{
      name:"Coworking",
      frame:55,
      pos:[1010.18,231.912]
    },{
      name:"BBQ2",
      frame:55,
      pos:[1017.31,233.671]
    },{
      name:"Lobby",
      frame:55,
      pos:[1056.07,856.699]
    },
    ],
    [
    {
      name:"Children's Play",
      frame:56,
      pos:[736.955,640.831]
    },{
      name:"Laundry",
      frame:56,
      pos:[787.161,225.807]
    },{
      name:"Pet Zone",
      frame:56,
      pos:[781.248,715.707]
    },{
      name:"Gym",
      frame:56,
      pos:[901.355,250.414]
    },{
      name:"Hall",
      frame:56,
      pos:[907.917,480.159]
    },{
      name:"Yoga Deck",
      frame:56,
      pos:[936.252,643.144]
    },{
      name:"Solarium",
      frame:56,
      pos:[937.803,235.456]
    },{
      name:"Coworking",
      frame:56,
      pos:[973.8,231.646]
    },{
      name:"Infinity Pool",
      frame:56,
      pos:[985.955,254.46]
    },{
      name:"Eco Terrace",
      frame:56,
      pos:[1000.04,246.051]
    },{
      name:"Children's Pool",
      frame:56,
      pos:[1001.7,234.207]
    },{
      name:"BBQ2",
      frame:56,
      pos:[1025.51,233.176]
    },{
      name:"Lobby",
      frame:56,
      pos:[1027.36,858.887]
    },
    ],
    [
    {
      name:"Children's Play",
      frame:57,
      pos:[692.251,637.332]
    },{
      name:"Laundry",
      frame:57,
      pos:[754.166,227.359]
    },{
      name:"Pet Zone",
      frame:57,
      pos:[802.906,712.636]
    },{
      name:"Yoga Deck",
      frame:57,
      pos:[884.718,642.445]
    },{
      name:"Hall",
      frame:57,
      pos:[892.803,479.831]
    },{
      name:"Gym",
      frame:57,
      pos:[910.32,250.78]
    },{
      name:"Coworking",
      frame:57,
      pos:[937.21,231.67]
    },{
      name:"Solarium",
      frame:57,
      pos:[964.573,235.513]
    },{
      name:"Lobby",
      frame:57,
      pos:[997.788,860.313]
    },{
      name:"Infinity Pool",
      frame:57,
      pos:[1017.25,254.171]
    },{
      name:"JacuzziView",
      frame:57,
      pos:[1016.49,230.695]
    },{
      name:"Children's Pool",
      frame:57,
      pos:[1020.4,233.796]
    },{
      name:"Eco Terrace",
      frame:57,
      pos:[1026.11,245.659]
    },{
      name:"BBQ2",
      frame:57,
      pos:[1033.27,232.616]
    },
    ],
    [
    {
      name:"Children's Play",
      frame:58,
      pos:[651.522,633.28]
    },{
      name:"Laundry",
      frame:58,
      pos:[723.835,229.153]
    },{
      name:"Yoga Deck",
      frame:58,
      pos:[834.372,641.01]
    },{
      name:"Pet Zone",
      frame:58,
      pos:[825.215,709.994]
    },{
      name:"Hall",
      frame:58,
      pos:[878.357,479.422]
    },{
      name:"Coworking",
      frame:58,
      pos:[900.912,231.985]
    },{
      name:"Gym",
      frame:58,
      pos:[919.585,251.082]
    },{
      name:"Lobby",
      frame:58,
      pos:[967.725,860.953]
    },{
      name:"Solarium",
      frame:58,
      pos:[991.323,235.363]
    },{
      name:"BBQ2",
      frame:58,
      pos:[1040.54,231.994]
    },{
      name:"JacuzziView",
      frame:58,
      pos:[1030.99,230.171]
    },{
      name:"Children's Pool",
      frame:58,
      pos:[1038.81,233.236]
    },{
      name:"Infinity Pool",
      frame:58,
      pos:[1048.39,253.669]
    },{
      name:"Eco Terrace",
      frame:58,
      pos:[1051.94,245.077]
    },
    ],
    [
    {
      name:"Children's Play",
      frame:59,
      pos:[615.185,628.759]
    },{
      name:"Laundry",
      frame:59,
      pos:[696.462,231.157]
    },{
      name:"Yoga Deck",
      frame:59,
      pos:[785.995,638.874]
    },{
      name:"Coworking",
      frame:59,
      pos:[865.4,232.585]
    },{
      name:"Pet Zone",
      frame:59,
      pos:[848.067,707.781]
    },{
      name:"Hall",
      frame:59,
      pos:[864.716,478.937]
    },{
      name:"Gym",
      frame:59,
      pos:[929.092,251.318]
    },{
      name:"Lobby",
      frame:59,
      pos:[937.546,860.795]
    },{
      name:"Solarium",
      frame:59,
      pos:[1017.96,235.004]
    },{
      name:"BBQ2",
      frame:59,
      pos:[1047.28,231.313]
    },{
      name:"Children's Pool",
      frame:59,
      pos:[1056.84,232.531]
    },{
      name:"Eco Terrace",
      frame:59,
      pos:[1077.44,244.307]
    },{
      name:"Infinity Pool",
      frame:59,
      pos:[1079.29,252.955]
    },
    ],
    [
    {
      name:"Children's Play",
      frame:60,
      pos:[583.53,623.86]
    },{
      name:"Laundry",
      frame:60,
      pos:[672.273,233.336]
    },{
      name:"Yoga Deck",
      frame:60,
      pos:[740.294,636.088]
    },{
      name:"Coworking",
      frame:60,
      pos:[831.141,233.457]
    },{
      name:"Hall",
      frame:60,
      pos:[852.004,478.381]
    },{
      name:"Pet Zone",
      frame:60,
      pos:[871.358,705.997]
    },{
      name:"Lobby",
      frame:60,
      pos:[907.633,859.843]
    },{
      name:"Gym",
      frame:60,
      pos:[938.78,251.488]
    },{
      name:"Solarium",
      frame:60,
      pos:[1044.4,234.438]
    },{
      name:"BBQ2",
      frame:60,
      pos:[1053.42,230.578]
    },{
      name:"Children's Pool",
      frame:60,
      pos:[1074.39,231.68]
    },{
      name:"Eco Terrace",
      frame:60,
      pos:[1102.52,243.346]
    },{
      name:"Infinity Pool",
      frame:60,
      pos:[1109.86,252.025]
    },
    ],
    [
    {
      name:"Children's Play",
      frame:61,
      pos:[556.72,618.669]
    },{
      name:"Laundry",
      frame:61,
      pos:[651.418,235.659]
    },{
      name:"Yoga Deck",
      frame:61,
      pos:[697.882,632.715]
    },{
      name:"Coworking",
      frame:61,
      pos:[798.57,234.586]
    },{
      name:"Hall",
      frame:61,
      pos:[840.332,477.761]
    },{
      name:"Lobby",
      frame:61,
      pos:[878.361,858.112]
    },{
      name:"Pet Zone",
      frame:61,
      pos:[894.989,704.643]
    },{
      name:"Gym",
      frame:61,
      pos:[948.589,251.591]
    },{
      name:"BBQ2",
      frame:61,
      pos:[1058.92,229.791]
    },{
      name:"Solarium",
      frame:61,
      pos:[1070.55,233.662]
    },{
      name:"Children's Pool",
      frame:61,
      pos:[1091.37,230.685]
    },{
      name:"Eco Terrace",
      frame:61,
      pos:[1127.06,242.195]
    },{
      name:"Infinity Pool",
      frame:61,
      pos:[1140.01,250.879]
    },
    ],
    [
    {
      name:"Children's Play",
      frame:62,
      pos:[534.808,613.273]
    },{
      name:"Laundry",
      frame:62,
      pos:[633.984,238.089]
    },{
      name:"Yoga Deck",
      frame:62,
      pos:[659.265,628.827]
    },{
      name:"Coworking",
      frame:62,
      pos:[768.072,235.95]
    },{
      name:"Hall",
      frame:62,
      pos:[829.792,477.084]
    },{
      name:"Lobby",
      frame:62,
      pos:[850.088,855.633]
    },{
      name:"Pet Zone",
      frame:62,
      pos:[918.864,703.718]
    },{
      name:"Gym",
      frame:62,
      pos:[958.459,251.626]
    },{
      name:"BBQ2",
      frame:62,
      pos:[1063.73,228.959]
    },{
      name:"Solarium",
      frame:62,
      pos:[1096.3,232.676]
    },{
      name:"Children's Pool",
      frame:62,
      pos:[1107.69,229.549]
    },{
      name:"Eco Terrace",
      frame:62,
      pos:[1150.95,240.854]
    },{
      name:"Infinity Pool",
      frame:62,
      pos:[1169.63,249.513]
    },
    ],
    [
    {
      name:"Children's Play",
      frame:63,
      pos:[517.744,607.752]
    },{
      name:"Laundry",
      frame:63,
      pos:[619.991,240.596]
    },{
      name:"Yoga Deck",
      frame:63,
      pos:[624.827,624.503]
    },{
      name:"Coworking",
      frame:63,
      pos:[739.979,237.526]
    },{
      name:"Hall",
      frame:63,
      pos:[820.462,476.357]
    },{
      name:"Lobby",
      frame:63,
      pos:[823.147,852.448]
    },{
      name:"Pet Zone",
      frame:63,
      pos:[942.889,703.224]
    },{
      name:"Gym",
      frame:63,
      pos:[968.331,251.593]
    },{
      name:"BBQ2",
      frame:63,
      pos:[1067.8,228.085]
    },{
      name:"Solarium",
      frame:63,
      pos:[1121.56,231.481]
    },{
      name:"JacuzziView",
      frame:63,
      pos:[1095.97,225.833]
    },{
      name:"Children's Pool",
      frame:63,
      pos:[1123.23,228.274]
    },{
      name:"Eco Terrace",
      frame:63,
      pos:[1174.08,239.321]
    },{
      name:"Infinity Pool",
      frame:63,
      pos:[1198.61,247.925]
    },
    ],
    [
    {
      name:"Children's Play",
      frame:64,
      pos:[505.398,602.179]
    },{
      name:"Yoga Deck",
      frame:64,
      pos:[594.835,619.826]
    },{
      name:"Laundry",
      frame:64,
      pos:[609.409,243.148]
    },{
      name:"Coworking",
      frame:64,
      pos:[714.561,239.287]
    },{
      name:"Hall",
      frame:64,
      pos:[812.403,475.59]
    },{
      name:"Lobby",
      frame:64,
      pos:[797.838,848.609]
    },{
      name:"Gym",
      frame:64,
      pos:[978.142,251.492]
    },{
      name:"Pet Zone",
      frame:64,
      pos:[966.974,703.158]
    },{
      name:"BBQ2",
      frame:64,
      pos:[1071.09,227.177]
    },{
      name:"JacuzziView",
      frame:64,
      pos:[1106.87,224.643]
    },{
      name:"Solarium",
      frame:64,
      pos:[1146.22,230.074]
    },{
      name:"Children's Pool",
      frame:64,
      pos:[1137.9,226.863]
    },{
      name:"Eco Terrace",
      frame:64,
      pos:[1196.32,237.598]
    },{
      name:"Infinity Pool",
      frame:64,
      pos:[1226.82,246.111]
    },
    ],
    [
    {
      name:"Children's Play",
      frame:65,
      pos:[497.573,596.621]
    },{
      name:"Yoga Deck",
      frame:65,
      pos:[569.443,614.877]
    },{
      name:"Laundry",
      frame:65,
      pos:[602.157,245.716]
    },{
      name:"Coworking",
      frame:65,
      pos:[692.029,241.205]
    },{
      name:"Lobby",
      frame:65,
      pos:[774.423,844.178]
    },{
      name:"Hall",
      frame:65,
      pos:[805.659,474.788]
    },{
      name:"Gym",
      frame:65,
      pos:[987.834,251.324]
    },{
      name:"Pet Zone",
      frame:65,
      pos:[991.027,703.523]
    },{
      name:"BBQ2",
      frame:65,
      pos:[1073.55,226.238]
    },{
      name:"JacuzziView",
      frame:65,
      pos:[1116.87,223.356]
    },{
      name:"Children's Pool",
      frame:65,
      pos:[1151.58,225.322]
    },{
      name:"Solarium",
      frame:65,
      pos:[1170.15,228.456]
    },{
      name:"Eco Terrace",
      frame:65,
      pos:[1217.53,235.685]
    },{
      name:"Infinity Pool",
      frame:65,
      pos:[1254.12,244.07]
    },
    ],
    [
    {
      name:"Children's Play",
      frame:66,
      pos:[494.027,591.133]
    },{
      name:"Yoga Deck",
      frame:66,
      pos:[548.699,609.735]
    },{
      name:"Laundry",
      frame:66,
      pos:[598.12,248.275]
    },{
      name:"Coworking",
      frame:66,
      pos:[672.527,243.25]
    },{
      name:"Lobby",
      frame:66,
      pos:[753.122,839.222]
    },{
      name:"Hall",
      frame:66,
      pos:[800.257,473.961]
    },{
      name:"Gym",
      frame:66,
      pos:[997.347,251.089]
    },{
      name:"Pet Zone",
      frame:66,
      pos:[1014.96,704.317]
    },{
      name:"BBQ2",
      frame:66,
      pos:[1075.17,225.277]
    },{
      name:"JacuzziView",
      frame:66,
      pos:[1125.88,221.977]
    },{
      name:"Children's Pool",
      frame:66,
      pos:[1164.16,223.654]
    },{
      name:"Solarium",
      frame:66,
      pos:[1193.24,226.626]
    },{
      name:"Eco Terrace",
      frame:66,
      pos:[1237.57,233.583]
    },{
      name:"Infinity Pool",
      frame:66,
      pos:[1280.36,241.799]
    },
    ],
    [
    {
      name:"Children's Play",
      frame:67,
      pos:[494.482,585.765]
    },{
      name:"Yoga Deck",
      frame:67,
      pos:[532.56,604.475]
    },{
      name:"Laundry",
      frame:67,
      pos:[597.152,250.802]
    },{
      name:"Coworking",
      frame:67,
      pos:[656.143,245.394]
    },{
      name:"Lobby",
      frame:67,
      pos:[734.111,833.816]
    },{
      name:"Hall",
      frame:67,
      pos:[796.212,473.117]
    },{
      name:"Gym",
      frame:67,
      pos:[1006.62,250.789]
    },{
      name:"Pet Zone",
      frame:67,
      pos:[1038.67,705.54]
    },{
      name:"BBQ2",
      frame:67,
      pos:[1075.9,224.3]
    },{
      name:"JacuzziView",
      frame:67,
      pos:[1133.82,220.514]
    },{
      name:"Children's Pool",
      frame:67,
      pos:[1175.54,221.865]
    },{
      name:"Solarium",
      frame:67,
      pos:[1215.35,224.585]
    },{
      name:"Eco Terrace",
      frame:67,
      pos:[1256.27,231.296]
    },{
      name:"Infinity Pool",
      frame:67,
      pos:[1305.37,239.296]
    },
    ],
    [
    {
      name:"Children's Play",
      frame:68,
      pos:[498.639,580.558]
    },{
      name:"Yoga Deck",
      frame:68,
      pos:[520.907,599.166]
    },{
      name:"Laundry",
      frame:68,
      pos:[599.084,253.276]
    },{
      name:"Coworking",
      frame:68,
      pos:[642.909,247.609]
    },{
      name:"Lobby",
      frame:68,
      pos:[717.52,828.033]
    },{
      name:"Hall",
      frame:68,
      pos:[793.522,472.262]
    },{
      name:"Gym",
      frame:68,
      pos:[1015.59,250.424]
    },{
      name:"BBQ2",
      frame:68,
      pos:[1075.73,223.314]
    },{
      name:"Pet Zone",
      frame:68,
      pos:[1062.08,707.193]
    },{
      name:"JacuzziView",
      frame:68,
      pos:[1140.6,218.972]
    },{
      name:"Children's Pool",
      frame:68,
      pos:[1185.6,219.964]
    },{
      name:"Solarium",
      frame:68,
      pos:[1236.34,222.333]
    },{
      name:"Eco Terrace",
      frame:68,
      pos:[1273.48,228.826]
    },{
      name:"Infinity Pool",
      frame:68,
      pos:[1328.96,236.559]
    },
    ],
    [
    {
      name:"Children's Play",
      frame:69,
      pos:[506.193,575.545]
    },{
      name:"Yoga Deck",
      frame:69,
      pos:[513.562,593.868]
    },{
      name:"Laundry",
      frame:69,
      pos:[603.735,255.679]
    },{
      name:"Coworking",
      frame:69,
      pos:[632.807,249.869]
    },{
      name:"Lobby",
      frame:69,
      pos:[703.437,821.949]
    },{
      name:"Hall",
      frame:69,
      pos:[792.174,471.404]
    },{
      name:"Gym",
      frame:69,
      pos:[1024.21,249.997]
    },{
      name:"BBQ2",
      frame:69,
      pos:[1074.64,222.328]
    },{
      name:"Pet Zone",
      frame:69,
      pos:[1085.07,709.276]
    },{
      name:"JacuzziView",
      frame:69,
      pos:[1146.14,217.361]
    },{
      name:"Children's Pool",
      frame:69,
      pos:[1194.21,217.958]
    },{
      name:"Solarium",
      frame:69,
      pos:[1256.04,219.873]
    },{
      name:"Eco Terrace",
      frame:69,
      pos:[1289,226.179]
    },{
      name:"Infinity Pool",
      frame:69,
      pos:[1350.92,233.588]
    },
    ],
    [
    {
      name:"Yoga Deck",
      frame:70,
      pos:[510.3,588.636]
    },{
      name:"Children's Play",
      frame:70,
      pos:[516.84,570.753]
    },{
      name:"Laundry",
      frame:70,
      pos:[610.914,257.997]
    },{
      name:"Coworking",
      frame:70,
      pos:[625.78,252.147]
    },{
      name:"Lobby",
      frame:70,
      pos:[691.908,815.641]
    },{
      name:"Hall",
      frame:70,
      pos:[792.143,470.551]
    },{
      name:"Gym",
      frame:70,
      pos:[1032.41,249.51]
    },{
      name:"BBQ2",
      frame:70,
      pos:[1072.62,221.348]
    },{
      name:"Pet Zone",
      frame:70,
      pos:[1107.56,711.788]
    },{
      name:"JacuzziView",
      frame:70,
      pos:[1150.37,215.691]
    },{
      name:"Children's Pool",
      frame:70,
      pos:[1201.27,215.857]
    },{
      name:"Solarium",
      frame:70,
      pos:[1274.3,217.207]
    },{
      name:"Eco Terrace",
      frame:70,
      pos:[1302.66,223.361]
    },{
      name:"Infinity Pool",
      frame:70,
      pos:[1371.03,230.386]
    },
    ],
    [
    {
      name:"Yoga Deck",
      frame:71,
      pos:[510.864,583.516]
    },{
      name:"Children's Play",
      frame:71,
      pos:[530.28,566.2]
    },{
      name:"Coworking",
      frame:71,
      pos:[621.732,254.422]
    },{
      name:"Laundry",
      frame:71,
      pos:[620.425,260.218]
    },{
      name:"Lobby",
      frame:71,
      pos:[682.941,809.18]
    },{
      name:"Hall",
      frame:71,
      pos:[793.393,469.709]
    },{
      name:"Gym",
      frame:71,
      pos:[1040.13,248.965]
    },{
      name:"BBQ2",
      frame:71,
      pos:[1069.66,220.383]
    },{
      name:"Pet Zone",
      frame:71,
      pos:[1129.43,714.728]
    },{
      name:"JacuzziView",
      frame:71,
      pos:[1153.21,213.971]
    },{
      name:"Children's Pool",
      frame:71,
      pos:[1206.66,213.672]
    },{
      name:"Solarium",
      frame:71,
      pos:[1290.92,214.341]
    },{
      name:"Eco Terrace",
      frame:71,
      pos:[1314.26,220.383]
    },{
      name:"Infinity Pool",
      frame:71,
      pos:[1389.04,226.955]
    },
    ],
    [
    {
      name:"Yoga Deck",
      frame:72,
      pos:[514.977,578.545]
    },{
      name:"Children's Play",
      frame:72,
      pos:[546.227,561.904]
    },{
      name:"Coworking",
      frame:72,
      pos:[620.542,256.674]
    },{
      name:"Laundry",
      frame:72,
      pos:[632.075,262.33]
    },{
      name:"Lobby",
      frame:72,
      pos:[676.51,802.635]
    },{
      name:"Hall",
      frame:72,
      pos:[795.881,468.883]
    },{
      name:"Gym",
      frame:72,
      pos:[1047.32,248.365]
    },{
      name:"BBQ2",
      frame:72,
      pos:[1065.79,219.442]
    },{
      name:"Pet Zone",
      frame:72,
      pos:[1150.56,718.096]
    },{
      name:"JacuzziView",
      frame:72,
      pos:[1154.59,212.215]
    },{
      name:"Children's Pool",
      frame:72,
      pos:[1210.28,211.417]
    },{
      name:"Solarium",
      frame:72,
      pos:[1305.73,211.28]
    },{
      name:"Eco Terrace",
      frame:72,
      pos:[1323.58,217.254]
    },{
      name:"Infinity Pool",
      frame:72,
      pos:[1404.67,223.302]
    },
    ],
    [
    
    ]
]

class Billboards extends Component{

    constructor(props){
        super(props);
        this.array = []
        this.state = {
            angle: 0,
            pos: []
        }
        
    }   

    componentDidMount(){
      
        this.billboard = <div></div>
    }

    createBillboards = () => {
        
        if(this.props.amenity.nombre !== ''){

          
          if(Amenities[this.props.angle]){
            if(Amenities[this.props.angle].length > 0){
                
              this.billboard = <div></div>
              for(let i = 0; i < Amenities[this.props.angle].length; i++)
              {
                  if(Amenities[this.props.angle][i].name === this.props.amenity.nombre){

                      
                      
                      /*this.setState(prevState => ({
                          pos: Amenities[this.props.angle][i].pos
                      }), 
                      () => {*/
                          this.billboard = <svg 
                          className = "billboards"
                          width="100vw"
                          height="100vh"
                          preserveAspectRatio="xMidYMid slice"
                          viewBox="0 0 1920 1080"
                          style={{
                              overflow: 'hidden',
                              pointerEvents: 'none',
                              position: 'absolute'
                              /*-webkit-user-drag: none,
                              -webkit-tap-highlight-color: rgba(0, 0, 0, 0)*/
                          }}>
                              <g style={{
                                  /*transform: 'matrix(1, 0, 0, 1, 8.5601e-05, -36.5)',*/
                                  pointerEvents: 'visiblefill',
                                  cursor: 'pointer'
                              }}
                              onClick = {this.props.gallery.length > 0 ? this.props.openGallery:console.log("false")}
                              onTouchStart = {this.props.gallery.length > 0 ? this.props.openGallery:console.log("false")}
                              >
                                  <circle 
                                      cx={Amenities[this.props.angle][i].pos[0]} 
                                      cy={Amenities[this.props.angle][i].pos[1]} 
                                      r="35" 
                                      style = {{
                                          fill:"rgba(238,116,7,.85)",
                                          stroke:"rgba(245,245,245,.85)",
                                          strokeWidth:1
                                      }}
                                  />
                                  <image 
                                      href={icons[this.props.amenity.nombre + '2']}
                                      width="40"
                                      height="40"
                                      x={Amenities[this.props.angle][i].pos[0]-20}
                                      y={Amenities[this.props.angle][i].pos[1]-20}
                                      /*style={{
                                          position: 'absolute',
                                          left:this.state.pos[0],
                                          top:this.state.pos[1]
                                      }}*/
                                      
                                  ></image>
                              </g>
                              
                          </svg>;
                          
                      //})
                      break;
                  }                    
              }
          } 
          else
          {
              this.billboard = <div></div>
          }

          }
            
            
            
        }
    }

    componentDidUpdate(prevProps){

        // TODO: check if this routine can be optimized
        
        if(!this.props.show){
            return
        } 
                
        if(prevProps.angle !== this.props.angle || prevProps.show !== this.props.show || prevProps.amenity !== this.props.amenity){
            //console.log(this.props)
            this.createBillboards();
            this.forceUpdate();            
        }
    }

    render() {
        if(this.props.show === false){
            return (<div></div>)
        }
        return (
            <div
                style={{
                    pointerEvents: 'none'
                }}
            >
                {this.billboard}
                
            </div>
            
        );
      
    }
}

Billboards.propTypes = {
    angle: PropTypes.number,
    openGallery: PropTypes.func
}

Billboards.defaultProps = {
    angle: 0,
    openGallery: () => {}
}

export default Billboards;